import {Axios} from '../axios/axios.js'
//组织列表
export const getOraList = (e) => {
  return Axios({
    url:"/index.php/organization/get_organization_list",
    method:'put',
    data:e
  })
}
//店铺列表
export const getStoreList = (e) => {
  return Axios({
    url:"/index.php/user/get_sub_organization_list",
    method:'put',
    data:e
  })
}
//新建组织
export const addNewOra = (e) => {
  return Axios({
    url:'/index.php/organization/add_organization',
    method:'put',
    data:e
  })
}
//编辑组织
export const editNewOra = (e) => {
  return Axios({
    url:'/index.php/organization/edit_organization',
    method:'put',
    data:e
  })
}
//删除组织
export const deleteOra = (e) => {
  return Axios({
    url:'/index.php/organization/del_organization',
    method:'put',
    data:e
  })
}
//新建 store
export const addStore = (e) => {
  return Axios({
    url:'/user/add_store',
    method:'put',
    data:e
  })
}
//删除 sub store
export const deleteSubData = (e) => {
  return Axios({
    url:'/user/del_store',
    method:'put',
    data:e
  })
}
//重置店铺密码
export const resetPassword = (e) => {
  return Axios({
    url:'/index.php/user/reset_sub_organization_password',
    method:'put',
    data:e
  })
}
// check username
export const checkUsername = (e) => {
  return Axios({
    url:'/index.php/user/check_sub_organization_name',
    method:'put',
    data:e
  })
}
// 生成邀请连接
export const inviteLink = (e) => {
  return Axios({
    url:'/invite/generate_invitation_link',
    method:'post',
    data:e
  })
}
//获取 store_id user/create_store_id
export const createStoreId = (e) => {
  return Axios({
    url:'/user/create_store_id',
    method:'post',
    data:e
  })
}
//编辑 店铺 user/edit_store
export const editStore = (e) => {
  return Axios({
    url:'/user/edit_store',
    method:'post',
    data:e
  })
}
//获取客户id /test/pay
export const getClientId = (e) => {
  return Axios({
    url:'/test/pay',
    method:'post',
    data:e
  })
}
